module.exports = __webpack_public_path__ + "media/images/firsttime_header04_pc-68bba70dfc798e6d223b2ded76a8b670.png";